var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_linear_544_34411)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20.875C21.933 20.875 23.5 19.308 23.5 17.375C23.5 15.442 21.933 13.875 20 13.875C18.067 13.875 16.5 15.442 16.5 17.375C16.5 19.308 18.067 20.875 20 20.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 17.375C28.75 25.25 20 31.375 20 31.375C20 31.375 11.25 25.25 11.25 17.375C11.25 15.0544 12.1719 12.8288 13.8128 11.1878C15.4538 9.54687 17.6794 8.625 20 8.625C22.3206 8.625 24.5462 9.54687 26.1872 11.1878C27.8281 12.8288 28.75 15.0544 28.75 17.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_544_34411",
    x1: -8.11245,
    y1: 31.9626,
    x2: 50.7716,
    y2: 1.40153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_34411"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 28,
    height: 28,
    rx: 5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.853ac0ff6535270e5045d62002ee83bb.svg";
export { ForwardRef as ReactComponent };